<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="auto">
        <h1>行业类型管理</h1>
      </v-col>
      <v-col cols="auto" align-self="center">
        <v-btn color="primary" @click="showCreateDialog()">
          新增行业类型
        </v-btn>
      </v-col>
    </v-row>
    
    <v-data-table
      :headers="headers"
      :items="industryTypes"
      :items-per-page="5"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn small @click="showEditDialog(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn small @click="showDeleteConfirm(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <create-industry-type-popup 
    ref="createPopup"
    @type-created="refresh"
    ></create-industry-type-popup>
    
    <edit-industry-type-popup
      ref="editPopup"
      :item="selectedIndustryType"
      @type-updated="refresh"
    ></edit-industry-type-popup>

    <delete-industry-type-confirmation
      ref="deleteConfirmation"
      :item="selectedIndustryType"
      @type-deleted="refresh"
    ></delete-industry-type-confirmation>
  </v-container>
</template>

<script>
import { dropdownOptionsApi } from '@/api/dropdownOptions'

export default {
  components: {
    CreateIndustryTypePopup: () => import('@/components/industryType/CreateIndustryTypePopup.vue'),
    DeleteIndustryTypeConfirmation: () => import('@/components/industryType/DeleteIndustryTypeConfirmation.vue'),
    EditIndustryTypePopup: () => import('@/components/industryType/EditIndustryTypePopup.vue')
  },
  created() {
    this.fetchIndustryTypes();
  },
  data() {
    return {
      headers: [
        { text: "行业类型名称", value: "name" },
        { text: "国内类型", value: "domestic"},
        { text: "创建时间", value: "createdDateTime" },
        { text: "操作", value: "actions", sortable: false },
      ],
      industryTypes: [],
      selectedIndustryType: {"name": "", "createdDate": ""},
      loading: false,
    }
  },
  methods: {
    showEditDialog(item) {
      this.selectedIndustryType = item;
      this.$refs.editPopup.open(item);
    },
    showDeleteConfirm(item) {
      this.selectedIndustryType = item;
      this.$refs.deleteConfirmation.open();
    },
    
    async refresh() {
      this.fetchIndustryTypes();
    },

    showCreateDialog() {
      this.$refs.createPopup.open();
    },

    async fetchIndustryTypes() {
      this.loading = true;
      try {
        const response = await dropdownOptionsApi.getIndustryTypes();
        this.industryTypes = response.data.map(industryType => ({
          ...industryType,
          id: industryType.id,
          name: industryType.name,
          domestic: industryType.domestic
        }));
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('获取列表失败：' + errorMessage);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.v-chip {
  margin-right: 8px;
}
</style>